const DEFAULT_MESSAGE = 'Container does not contain node or range';

export class ContainmentError extends Error {
  constructor(message = DEFAULT_MESSAGE) {
    super(message);
  }
}
